<div id="higonelement" class="higon-buttons" [dir]="arenaService.rtlEnabled ? 'rtl' : 'auto'">
  <mat-icon
    svgIcon="info_db"
    class="info-icon"
    matTooltip="{{ arenaService.res('Higon-InsertedOn') }}: {{
      actionAndInfoDetails.InsertOn ? getDateTime(actionAndInfoDetails.InsertOn, actionAndInfoDetails.InsertAt) : null
    }} &#10; &#13;{{ arenaService.res('Higon-InsertedBy') }}: {{ actionAndInfoDetails.InsertBy }}&#13;&#10;
        {{ arenaService.res('Higon-RefreshedOn') }}: {{
      actionAndInfoDetails.UpdateOn ? getDateTime(actionAndInfoDetails.UpdateOn, actionAndInfoDetails.UpdateAt) : null
    }}&#13; &#10;{{ arenaService.res('Higon-RefreshedBy') }}: {{ actionAndInfoDetails.UpdateBy }}"
    [matTooltipClass]="'higon-tooltip'"
  >
  </mat-icon>
  <mat-button-toggle-group
    class="higon-toggle-group"
    name="fontStyle"
    #group="matButtonToggleGroup"
    aria-label="Font Style"
    multiple="true"
    appearance="legacy"
    [hideMultipleSelectionIndicator]="true"
  >
    <mat-button-toggle
      #propertiesButton
      value="Properties"
      (click)="openGalleryItem('Properties', group.value)"
      [checked]="settings?.isPropertiesChecked"
      [disabled]="
        settings?.isPropertiesDisabled !== false ||
        settings?.isPropertiesAvailable !== true ||
        !settings?.selectedObject?.Object?.Id
      "
    >
      <mat-icon
        svgIcon="properties_db"
        matTooltip="{{ arenaService.res('Higon-Properties') }}"
        matBadge="{{ actionAndInfoDetails.Properties || '' }}"
        [matTooltipClass]="'higon-tooltip'"
      ></mat-icon>
    </mat-button-toggle>
    <mat-button-toggle
      #documentsButton
      value="Documents"
      (click)="openGalleryItem('Documents', group.value)"
      [checked]="settings?.isDocumentsChecked"
      [disabled]="
        settings?.isDocumentsDisabled !== false ||
        settings?.isDocumentsAvailable !== true ||
        !settings?.selectedObject?.Object?.Id
      "
    >
      <mat-icon
        svgIcon="documents_db"
        matTooltip="{{ arenaService.res('Higon-Documents') }}"
        matBadge="{{ actionAndInfoDetails.Documents || '' }}"
        [matTooltipClass]="'higon-tooltip'"
      ></mat-icon>
    </mat-button-toggle>
    <mat-button-toggle
      #commentsButton
      value="Comments"
      (click)="openGalleryItem('Comments', group.value)"
      [checked]="settings?.isCommentsChecked"
      [disabled]="
        settings?.isCommentsDisabled !== false ||
        settings?.isCommentsAvailable !== true ||
        !settings?.selectedObject?.Object?.Id
      "
    >
      <mat-icon
        svgIcon="comments_db"
        matTooltip="{{ arenaService.res('Higon-Comments') }}"
        matBadge="{{ actionAndInfoDetails.Comments || '' }}"
        [matTooltipClass]="'higon-tooltip'"
      ></mat-icon>
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>
<abc-list
  #higonListBox
  searchExpr="text"
  searchMode="contains"
  showTemplateImage="true"
  [activeStateEnabled]="false"
  [collapsibleGroups]="true"
  [dataSource]="navigationAndActionDataSource"
  [displayExpr]="'text'"
  [focusStateEnabled]="false"
  [grouped]="true"
  [height]="listBoxHeight"
  [ngClass]="noDataStyle == true ? 'noDataStyle' : ''"
  [rtlEnabled]="rtlEnabled"
  [scrollingEnabled]="true"
  [searchEnabled]="true"
  [selectionMode]="'single'"
  [width]="'250px'"
  (onItemClick)="onItemClick($event)"
  [disabled]="listBoxDisabled ?? !settings?.selectedObject?.Object?.Id"
>
  @if ((resAsync | async) && showTemplateImage) {
    <div>
      <div *dxTemplate="let item of 'item'">
        @if (item.imageSrc) {
          <img class="higon-command-image" src="{{ item.imageSrc }}" />
        }
        @if (!item.imageSrc) {
          <mat-icon
            class="higon-command-image"
            [svgIcon]="item.imageType ? res.svgName(item.imageType + '-Image') : ''"
          ></mat-icon>
        }
        <div>{{ item.text }}</div>
      </div>
    </div>
  }
  <div *dxTemplate="let group of 'group'">
    <div>{{ abcListDisplayTextDictionary[group.key] }}</div>
  </div>
</abc-list>
